import { Tabs, TabsProps } from '@mui/material';
import React from 'react';

const TabsWrapper: React.FC<TabsProps> = ({ ...props }) => <Tabs {...props} />;

export default TabsWrapper;
